import React from 'react';
import { Icon } from 'components/common/Icon';
import styled, { css } from 'styled-components';

export function Button({ children, onClick, icon, ...props }) {
  return (
    <BtnContainer $mode={props.mode} onClick={onClick}>
      {icon && <Icon name={icon} $pathFill={props.$pathFill} />}
      {children}
    </BtnContainer>
  );
}

const BtnContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $mode, theme }) =>
    ($mode === 'chip' &&
      css`
        border-radius: 12px;
        padding: 3px 8px;
        background-color: ${theme.colors.fill20};
        border: 1px solid ${theme.colors.fill05};
        gap: 2px;

        &:active {
          background-color: ${theme.colors.assistive};
          border: 1px solid ${theme.colors.fill05};
        }
      `) ||
    ($mode === 'text' &&
      css`
        border-radius: 4px;
        padding: 4px;
        gap: 2px;
        background-color: transparent;

        &:active {
          background-color: ${theme.colors.disabled};
        }
      `) ||
    css`
      width: 100%;
      border-radius: 10px;
      height: 50px;
      background-color: ${theme.colors.primary};
      box-shadow: ${theme.shadows.elevation03};
    `}
`;
